<div class="page">
  <header class="page-header">
    <h1>Nuova richiesta valutazione assistito</h1>
    <p class="subtitle">Modifica il JSON del Bundle FHIR e invialo al sistema COT.</p>
    <a mat-button routerLink="/home">← Torna alla home</a>
  </header>

  <div class="toolbar">
    <button mat-raised-button (click)="caricaTemplate()">Carica template</button>
    <button mat-button (click)="formatta()">Formatta JSON</button>
    <button mat-raised-button color="primary" (click)="invia()" [disabled]="sending">
      @if (sending) {
        <mat-spinner diameter="20"></mat-spinner>
        <span class="btn-label">Invio in corso…</span>
      } @else {
        Invia richiesta
      }
    </button>
  </div>

  @if (jsonError) {
    <div class="message error">
      Errore JSON: {{ jsonError }}
    </div>
  }
  @if (errorMessage) {
    <div class="message error">
      {{ errorMessage }}
    </div>
  }
  @if (successMessage) {
    <div class="message success">
      {{ successMessage }}
    </div>
  }

  <mat-form-field class="editor-field" appearance="outline">
    <mat-label>Bundle FHIR (JSON)</mat-label>
    <textarea
      matInput
      [(ngModel)]="bundleJson"
      rows="28"
      placeholder="Incolla o modifica il JSON del Bundle..."
      class="json-textarea"
    ></textarea>
  </mat-form-field>
</div>
